import { ReduxModel } from 'core/models';

const authSelector = ({ auth }: ReduxModel.IGlobalState) => auth;

export default authSelector;
